<style scoped>

</style>
<template>
    <Drawer
        v-model="config.modal"
        width="640"
        title="发票导出"
        >
        <div class="text-center">
            <Divider>关联发票导出</Divider>
            <div class="line">
                <DatePicker type="daterange" @on-change="daterangeChange" :options="date_option" placeholder="选择付款报销申请日期" style="width: 200px"></DatePicker>
                <Button type="primary" :loading="loading" @click="exportResource">导出</Button>
            </div>
            <Divider>发票列表导出</Divider>
            <div class="line">
                <Select v-model="invoice_params.valid_type" placeholder="验真类型" style="width: 120px">
                    <Option value="all">所有验真类型</Option>
                    <Option value="pending">未验真</Option>
                    <Option value="success" class="color-success">验真成功</Option>
                    <Option value="fail" class="color-error">验真失败</Option>
                </Select>
                <DatePicker type="daterange" @on-change="validDaterangeChange" :options="date_option" placeholder="录入日期" style="width: 200px"></DatePicker>
                <Button type="primary" :loading="loading" @click="exportValidation">导出</Button>
            </div>
            <Divider>发票分配金额/税额核对导出</Divider>
            <div class="line">
                <Select v-model="check_params.time_item" placeholder="日期维度" style="width: 100px">
                    <Option value="created_at">申请时间</Option>
                    <Option value="verified_at">入账会计期</Option>
                    <Option value="paid_at">付款时间</Option>
                </Select>
                <DatePicker type="daterange" @on-change="checkDaterangeChange" :options="date_option" placeholder="选择日期" style="width: 200px"></DatePicker>
                <Button type="primary" :loading="loading" @click="exportCheck">导出</Button>
            </div>
        </div>
    </Drawer>
</template>
<script>
    export default {
        data(){
            return {
                config: {
                    modal: false
                },
                params: {
                    daterange: [],
                },
                invoice_params: {
                    daterange: [],
                    valid_type: 'all'
                },
                check_params: {
                    time_item: 'created_at',
                    daterange: [],
                },
                loading: false,
                date_option: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近一个月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近三个月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近一年',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                                return [start, end];
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            show(){
                this.config.modal = true;
            },
            daterangeChange(daterange){
                this.params.daterange = daterange;
            },
            validDaterangeChange(daterange){
                this.invoice_params.daterange = daterange;
            },
            checkDaterangeChange(daterange) {
                this.check_params.daterange = daterange;
            },
            checkValid(){
                if(this.params.daterange.length === 0){
                    this.$Message.error({title: '提示', content: '请选择日期'});
                    return false;
                }
                return true;
            },
            exportResource(){
                if(!this.checkValid()) return;
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.export_invoice, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.config.modal = false;
                        this.$emit("done");
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            checkListValid(){
                if(this.invoice_params.daterange.length === 0){
                    this.$Message.error({title: '提示', content: '请选择日期'});
                    return false;
                }
                return true;
            },
            exportValidation() {
                if(!this.checkListValid()) return;
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.export_invoice_list, {
                    params: this.invoice_params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.config.modal = false;
                        this.$emit("done");
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            checkCheckParamsValid(){
                if(this.check_params.daterange.length === 0){
                    this.$Message.error({title: '提示', content: '请选择日期'});
                    return false;
                }
                return true;
            },
            exportCheck() {
                if(!this.checkCheckParamsValid()) return;
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.export_expense_group_invoice_check, {
                    params: this.check_params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.config.modal = false;
                        this.$emit("done");
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            }
        }
    }
</script>
